import UsersPage from './users-page';

export default UsersPage;